import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Task } from '@core/interfaces/tasks';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
import { MaintenanceDialogData } from '../../dialog-maintenances.component';


@Component({
  selector: 'tab-tasks',
  templateUrl: './tab-tasks.component.html',
  encapsulation: ViewEncapsulation.None
})
export class TabTasksComponent {
  public tasks: Task[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MaintenanceDialogData,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
    this.tasks = data.maintenance.tasks;
  }
}
